export default {
  general: {
    lastUpdate: null,
    loading: false,
    data: {},
  },
}
